import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';

export interface DeploymentContextState {
    cnum: string,
    ctx: string,
    serverBase: string,
    error: string
}

export const initialState: DeploymentContextState = {
    cnum: '',
    ctx: '',
    serverBase: '',
    error: ''
};

const slice = createSlice({
    name: 'deployment-context',
    initialState: initialState,
    reducers: {
        setDeploymentContext: (draft: Draft<DeploymentContextState>, {payload}: PayloadAction<DeploymentContextState>): void => {
            draft.cnum = payload.cnum;
            draft.ctx = payload.ctx;
            draft.serverBase = payload.serverBase;
            draft.error = payload.error;
        }
    },
});

export const actions = {
    ...slice.actions
};

export default slice.reducer;

